const coi_endpoint: string | undefined = process.env.REACT_APP_COI_ENDPOINT;
const root_url: string = process.env.REACT_APP_PUBLIC_FORM_SERVICE_ROOT_URL!;
export const url: string =
  root_url +
  (coi_endpoint
    ? coi_endpoint + "/"
    : /(?:\/\/)(.*)(?=-pff)/.exec(window.location.href)![1] + "/");
